<template>
  <div>
    <div class="whatsapp-integration-widget">
      <div style="overflow: hidden;">
        <div class="we-icon">
          <v-icon v-if="!socket_loading" size="40" color="#fff">mdi-whatsapp</v-icon>
          <v-icon v-else size="40" color="#fff">mdi-wifi-sync</v-icon>
        </div>
        <div class="we-description">
          <h3>Lembretes Whatsapp</h3>
          <span v-if="!socket_loading">Pronto para realizar envios.</span>
          <span v-else >Aguardando conexão...</span>
        </div>
      </div>
      <div v-if="client_info && !socket_loading" class="wa-button">
        <v-btn
          @click="integration_modal = true"
          block
          elevation="0"
          outlined
          small
          dark
        >Configurações</v-btn>
      </div>
    </div>

    <v-dialog
      v-if="client_info"
      v-model="integration_modal"
      content-class="whatsapp-integration-dialog"
      transition="dialog-bottom-transition"
      fullscreen
      hide-overlay
      persistent
    >
      <div class="header">
        <div @click="integration_modal = false" class="close">
          <v-icon color="white">mdi-close</v-icon>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div @click="openReminderPanel()" v-bind="attrs" v-on="on" class="config mr-4">
              <v-icon color="white">mdi-note-edit</v-icon>
            </div>
          </template>
          <span>Configurar lembretes</span>
        </v-tooltip>
        <h2>Lembretes WhatsApp</h2>
      </div>
      <div class="dialog-content">
        <div class="client-picture" :style="'background: url(' + client_info.photo + ')'">
          <div class="picture-effect"></div>
        </div>

        <div class="client-info">
          <div style="float: left; margin-top: 13px; margin-right: 18px; margin-left: 8px;">
            <div :class="['client-status', clientStatus]"></div>
          </div>
          <div class="client-data">
            <div class="name">{{ client_info.name }}</div>
            <div class="number">{{ formatPhoneNumber(client_info.phone) }}</div>
          </div>
          <div class="client-action">
            <v-btn
              v-if="shipping_online"
              @click="disableShipping()"
              :loading="loading"
              dark
              small
              outlined
              color="#4A5568"
              height="32px"
              style="margin-top: 3px;"
            >
              <v-icon left>
              mdi-pause-circle-outline
              </v-icon>
              PAUSAR ENVIOS
            </v-btn>
            <v-btn
              v-else
              @click="enableShipping()"
              :loading="loading"
              dark
              small
              depressed
              color="#41A982"
              height="32px"
              style="margin-top: 3px;"
            >
              <v-icon left>
              mdi-send-circle-outline
              </v-icon>
              ATIVAR ENVIOS
            </v-btn>
          </div>
        </div>

        <div class="messages">
          <v-alert dense text prominent border="left" color="primary">
            <v-icon color="primary" size="16">mdi-lock</v-icon> <b>Valorizamos sua privacidade</b><br/> <small>Não armazenamos as mensagens dos clientes e as mesmas não passam por nossos servidores.</small>
          </v-alert>

          <!-- <v-btn @click="requestSendTextMessage()" block class="mt-2" color="primary" outlined dark depressed large>
            mensagem de texto
          </v-btn>
          <v-btn @click="requestSendImageMessage()" block class="mt-2" color="primary" outlined dark depressed large>
            mensagem de imagem
          </v-btn>
          <v-btn @click="requestSendAudioMessage()" block class="mt-2" color="primary" outlined dark depressed large>
            mensagem de audio
          </v-btn>
          <hr class="my-4" /> -->

          <div class="message-tabs">
            <div @click="message_tabs = 0" class="tab" :class="{ 'active': message_tabs == 0 }">Enviando agora</div>
            <div @click="message_tabs = 1" class="tab" :class="{ 'active': message_tabs == 1 }">Histórico</div>
          </div>

          <v-tabs-items v-model="message_tabs">
            <v-tab-item>
              <div class="message-list">
                <div v-if="shipments.pending.length > 0">
                  <div class="message" v-for="pending in shipments.pending" :key="pending.id">
                    <v-progress-linear
                      v-if="pending.status === 'sending'"
                      style="height: 4px; margin-top: -12px; position: absolute; left: 0;"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                    <div class="client-photo">
                      <v-icon v-if="shipping_online" class="rotate-animation">mdi-sync</v-icon>
                      <v-icon v-else>mdi-pause-circle</v-icon>
                    </div>
                    <div class="client-data">
                      <div class="name">{{ reminder_types[pending.action_code].name }}</div>
                      <div class="number">{{ formatPhoneNumber(pending.sent_to_number) }}</div>
                    </div>
                    <div v-if="pending.status !== 'sending'" class="message-action">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" class="delete"><v-icon color="#F56565" size="28">mdi-trash-can-outline</v-icon></div>
                        </template>
                        <span>Cancelar</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
                <div v-else class="no-messages-queue">
                  <img :src="require('@/assets/notificaiton-queue-whatsapp.png')" /><br/>
                  <span>Aguardando envios...</span>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="message-list">
                <div v-if="shipments.sent.length > 0">
                  <div class="message" v-for="sent in shipments.sent" :key="sent.id">
                    <div class="client-photo">
                      <v-icon>{{ reminder_types[sent.action_code].icon }}</v-icon>
                    </div>
                    <div class="client-data">
                      <div class="name">{{ reminder_types[sent.action_code].name }}</div>
                      <div class="number">{{ formatPhoneNumber(sent.sent_to_number) }} - {{ new Date(sent.sent_at).toLocaleDateString('pt-BR', { year: '2-digit', month: '2-digit', day: '2-digit' }) }} às {{ new Date(sent.sent_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="no-messages-queue">
                  <img :src="require('@/assets/notificaiton-queue-whatsapp.png')" /><br/>
                  <span>Sem mensagens enviadas ainda...</span>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>

        <div class="footer">
          <img height="30px" :src="require('@/assets/logo_check_motors.png')">
        </div>

      </div>
    </v-dialog>
  </div>
</template>

<script>
import io from 'socket.io-client';
import messageRingAudio from '@/assets/whatsapp_message_send.mp3';

export default {
  name: 'WhatsappIntegrationDialog',
  data: () => ({
    loading: false,
    socket: null,
    socket_loading: true,
    shipping_online: false,
    integration_modal: false,
    client_info: null,
    message_tabs: 0,
    shipments: {
      pending: [],
      sent: [],
    },
    reminder_types: {
      MESSAGE_FOR_BIRTHDAY_PEOPLE: {
        name: 'Mensagem de aniversário',
        icon: 'mdi-cake-variant',
      }
    },
  }),
  computed: {
    clientStatus() {
      return this.shipping_online ? 'online' : 'offline';
    }
  },
  created() {

    setInterval(() => {
      this.processShipmentsPending();
    }, 5000);

    this.socket = io('https://ws.checkmotors.net', {
      withCredentials: true,
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
      path: '/whatsapp-checkmotors',
      auth: {
        userToken: '3ce192d3f5cfe5fe739e7eee99413148'
      }
    });

    this.socket.on('connect', () => {
      this.socket_loading = false;
    });

    this.socket.on('action', (action) => {
      if (action.type === 'reminder') {
        const shipmentExists = this.shipments.pending.some(shipment => shipment.id === action.content.id) || this.shipments.sent.some(shipment => shipment.id === action.content.id);
        if (!shipmentExists) {
          this.shipments.pending.push({...action.content, status: 'waiting'});
        }
      }
    });

    this.socket.on('disconnect', (reason) => {
      console.log('Disconnected from server. Reason:', reason);
    });
  },
  mounted() {
    // eslint-disable-next-line no-unneeded-ternary
    this.shipping_online = localStorage.getItem('shipping_online') === 'true' ? true : false;
    this.requestConnectWhatsapp();
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    processShipmentsPending() {
      if (this.shipping_online && this.shipments.pending.length > 0) {
        if (this.shipments.pending[0].status !== 'sending') {
          this.shipments.pending[0].status = 'sending';
          this.shipments.pending[0].sent_at = new Date();
          this.shipments.pending[0].reminder_messages.sort((a, b) => a.order - b.order)
          this.processMessagesWithDelay(this.shipments.pending[0].reminder_messages, this.shipments.pending[0].sent_to_number).then(() => {
            this.socket.emit('reminderSentConfirmation', this.shipments.pending[0].id);
            this.shipments.pending[0].status = 'processed';
            this.shipments.sent.push(this.shipments.pending[0]);
            this.shipments.pending.splice(0, 1);
            this.playSendRing();
          });
        }
      }
    },
    async delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async processMessagesWithDelay(messages, sentPhone) {
      return messages.reduce((promiseChain, message) =>
        promiseChain
            .then(() => this.processMessage(message, sentPhone))
            .then(() => this.delay(parseInt(message.delay_seconds, 10) * 1000)),
        Promise.resolve()
      );
    },
    processMessage(message, sentPhone) {
      switch (message.content_type) {
        case 'text':
          this.requestSendTextMessage(message, sentPhone);
        break;

        case 'image':
        this.requestSendImageMessage(message, sentPhone);
        break;

        case 'audio':
        this.requestSendAudioMessage(message, sentPhone)
        break;

        default:
          console.log('error switch message')
      }
    },
    handleMessage(event) {
      // if (event.origin === window.location.href.slice(0, -1)) {
      //   return
      // }
      const message = event.data;
      console.log(message)
      if (message) {
        const messageCode = message[0];
        const messageData = message[1] ? JSON.parse(message[1]) : null;
        switch (messageCode) {
          case 'response_connect_client':
            this.setConnectWhatsapp(messageData);
          break;

          case 'response_send_text':
            this.setStatusTextMessage(messageData);
          break;

          case 'response_send_image':
            this.setStatusImageMessage(messageData);
          break;

          case 'response_send_audio':
            this.setStatusAudioMessage(messageData);
          break;

          default:
          break;
        }
      }
    },
    requestConnectWhatsapp() {
      window.parent.postMessage('request_connect_client#', '*');
    },
    requestSendTextMessage(message, sentPhone) {
      if (!this.shipping_online) {
        return
      }
      const textMessage = {
        id: message.id,
        number: sentPhone,
        content: message.automatic_tag ? '> Mensagem Automática \n' + message.content : message.content
      };
      window.parent.postMessage('request_send_text#' + JSON.stringify(textMessage), '*');
    },
    async requestSendImageMessage(message, sentPhone) {
      if (!this.shipping_online) {
        return
      }
      await this.urlToBase64(message.content).then(base64 => {
        const imageMessage = {
          id: message.id,
          number: sentPhone,
          photo: base64
        };
        window.parent.postMessage('request_send_image#' + JSON.stringify(imageMessage), '*');
      });
    },
    async requestSendAudioMessage(message, sentPhone) {
      if (!this.shipping_online) {
        return
      }
      await this.urlToBase64(message.content).then(base64 => {
        const audioMessage = {
          id: message.id,
          number: sentPhone,
          audio: base64
        };
        window.parent.postMessage('request_send_audio#' + JSON.stringify(audioMessage), '*');
      });
    },
    async setConnectWhatsapp(clientInfo) {
      const self = this;
      self.client_info = clientInfo;

      await self.downloadImageAndConvertToBase64(clientInfo.photo).then(blob => {
        const reader = new FileReader();
        reader.onload = () => {
          const imageBase64Data = reader.result;
          self.socket.emit('requestSocket', {
            connectedNumber: clientInfo.phone,
            connectedPhoto: imageBase64Data,
            connectedName: clientInfo.name,
            activeShipping: self.shipping_online,
          });
        };
        reader.readAsDataURL(blob);
      })
      .catch(error => {
        console.error('Erro ao baixar a imagem:', error);
      });
    },
    setStatusTextMessage(message) {
      console.log(message)
    },
    setStatusImageMessage(message) {
      console.log(message)
    },
    setStatusAudioMessage(message) {
      console.log(message)
    },
    enableShipping() {
      this.shipping_online = true;
      this.socket.emit('startShipments');
      localStorage.setItem('shipping_online', true);
    },
    disableShipping() {
      this.shipping_online = false;
      this.socket.emit('stopShipments');
      localStorage.setItem('shipping_online', false);
    },
    async urlToBase64(url) {
      const response = await fetch(url, { cache: 'force-cache' });

      if (!response.ok) {
        throw new Error(`Failed to fetch the file from URL: ${url}`);
      }

      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result.split(',')[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    formatPhoneNumber(phoneNumber) {
      let cleaned = ('' + phoneNumber).replace(/\D/g, '');
      let countryCode = '';

      if (cleaned.startsWith('55')) {
        countryCode = '+55 ';
        cleaned = cleaned.substring(2);
      }

      const hasNineDigit = cleaned.length === 11;
      let formattedNumber = '';

      if (hasNineDigit) {
        formattedNumber = cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        formattedNumber = cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
      return countryCode + formattedNumber;
    },
    downloadImageAndConvertToBase64(url) {
      return fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Falha ao baixar a imagem');
          }
          return response.blob();
        });
    },
    playSendRing() {
      const audio = new Audio(messageRingAudio);
      audio.play();
    },
    openReminderPanel() {
      window.open('https://web.checkmotors.net/whatsapp/lembretes', '_blank');
    },
    returnScreen() {
      this.$emit('return');
    },
  },
};
</script>

<style lang="scss">
.whatsapp-integration-widget {
  background-color: #25d366;
  border-radius: 14px;
  color: #fff;
  width: 320px;
  margin: 30px auto;
  margin-top: 20px;
  margin-bottom: 40px;
  padding: 15px;
  overflow: hidden;
  transition: all 0.5s;
  animation: pulser 3s infinite;

  .we-icon {
    float: left;
    background-color: #16ba54;
    padding: 10px;
    border-radius: 50%;
    width: 60px;
  }

  .wa-button {
    border-top: 1px dashed #fff;
    margin-top: 12px;
    padding-top: 12px;
    overflow: hidden;
  }

  .we-description {
    float: left;
    line-height: 24px;
    padding-top: 8px;
    padding-left: 12px;
    width: calc(100% - 60px);
  }
}

.whatsapp-integration-dialog {

  .header {
    padding: 20px 28px;
    color: #fff;
    position: fixed;
    width: 100%;
    z-index: 999;

    h2 {
      padding-top: 4px;
    }

    .config {
      float: right;
      background-color: #3e5b75;
      border-radius: 50%;
      padding: 10px;
      cursor: pointer;
    }

    .close {
      float: right;
      background-color: #3e5b75;
      border-radius: 50%;
      padding: 10px;
      cursor: pointer;
    }
  }

  .dialog-content {

    .client-picture {
      height: 224px;
      background-size: cover !important;
      background-position: center !important;

      .picture-effect {
        background: #1D3C58B2;
        height: 100%;
        width: 100%;
      }
    }

    .client-info {
      width: 368px;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #E2E8F0;
      margin: -30px auto;

      .client-status {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: relative;

        &.online {
          background-color: #48BB78;
          animation: pulseGreen 3.5s infinite;
        }

        &.offline {
          background-color: #FF0000;
          animation: pulseRed 3.5s infinite;
        }
      }

      .client-data {
        float: left;
        line-height: 20px;

        .name {
          color: #4A5568;
          font-weight: 700;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 124px;
        }

        .number {
          color: #718096;
          font-weight: 400;
          font-size: 14px;
        }
      }

      .client-action {
        float: right
      }
    }

    .messages {
      margin: 43px auto;
      width: 368px;
      background-color: #fff;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #E2E8F0;

      .message-tabs {
        display: flex;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        height: 32px;

        .tab {
          flex: 1;
          text-align: center;
          padding: 5px;
          cursor: pointer;
          font-size: 14px;
          background-color: #F6F7F9;
          color: #333;

          &:nth-child(2) {
            border-left: 1px solid #E2E8F0;
            border-right: 1px solid #E2E8F0;
          }

          &.active {
            font-weight: bold;
            background-color: #41A982;
            color: white;
          }

          &:not(.active):hover {
            background-color: #e6e6e6;
          }
        }
      }

      .message-list {
        height: 350px;
        overflow-y: auto;

        .no-messages-queue {
          text-align: center;
          margin-top: 20px;
          padding-top: 70px;

          img {
            height: 100px;
            opacity: 0.7;
          }
        }

        .message {
          padding: 12px;
          background-color: #F6F7F9;
          border: 1px solid #E2E8F0;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 10px;

          &:hover {
            background-color: #48b38b17 !important;
            cursor: pointer;
          }

          .client-photo {
            background-color: #d9d9d9;
            padding: 6px;
            float: left;
            width: 36px;
            text-align: center;
            border-radius: 50%;
            margin-right: 12px;
            margin-top: 3px;
          }

          .client-data {
            float: left;
            line-height: 22px;

            .name {
              color: #4A5568;
              font-weight: 700;
              font-size: 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 214px;
            }

            .number {
              color: #718096;
              font-weight: 400;
              font-size: 14px;
            }
          }

          .message-action {
            float: right;
            padding-top: 4px;
            cursor: pointer;

            div {
              float: left;
              margin: 0 8px;
            }
          }
        }
      }
    }

    .footer {
      text-align: center;
      filter: grayscale(1);
    }
  }
}

.rotate-animation {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}

@keyframes pulseGreen {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(72, 187, 120, 0);
  }
}

@keyframes pulseRed {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
}
</style>
